import type { CopyFileFailedStatusDatagramBuf, CopyFileProgressStatusDatagramBuf, CopyFinishedStatusDatagramBuf, CopyStartedStatusDatagramBuf } from "~/classes/generated/status"

import { InterfaceFile } from "~/classes/file/InterfaceFile"
import { parseFile } from "~/utils/flatbuffers/file"
import { parseFileId } from "~/utils/flatbuffers/id"
import { parseTransferId } from "~/utils/flatbuffers/local"

const console = useLogger("local/copy")

export function handleCopyStartedStatusDatagramBuf(buf: CopyStartedStatusDatagramBuf) {
  const { onCopyJobStarted } = useJobs()

  const status: CopyStartedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    folderId: parseFileId(buf.folderId()!),
    approxTotal: buf.approxTotal(),
    approxTotalBytes: buf.approxTotalBytes(),
  }

  console.debug("Copy Started", status)
  onCopyJobStarted(status)
}

export function handleCopyFileProgressStatusDatagramBuf(buf: CopyFileProgressStatusDatagramBuf) {
  const { onCopyFileProgressStatus } = useJobs()

  const status: CopyFileProgressStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    fileId: parseFileId(buf.fileId()!),
    completedBytes: buf.completedBytes(),
    totalBytes: buf.totalBytes(),
  }

  console.debug("Transfer Status", status)
  onCopyFileProgressStatus(status)
}

export function handleCopyFileFailedStatusDatagramBuf(buf: CopyFileFailedStatusDatagramBuf) {
  const { notify } = useAlerts()

  const status: CopyFileFailedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    file: parseFile(buf.file()!),
  }

  console.debug("Transfer Status", status)

  const file = new InterfaceFile(status.file)
  notify({
    transferId: generateWorkerRequestId(),
    type: "error-alert",
    errorType: "copy-file-failed",
    file,
    timestamp: Date.now(),
    title: "A file failed to copy",
    description: "Details are scant right now",
  })
}

export function handleCopyFinishedStatusDatagramBuf(buf: CopyFinishedStatusDatagramBuf) {
  const { onCopyJobFinished } = useJobs()

  const status: CopyFinishedStatusDatagram = {
    transferId: parseTransferId(buf.transferId()!),
    folderId: parseFileId(buf.folderId()!),
    approxTotal: buf.approxTotal(),
    approxTotalBytes: buf.approxTotalBytes(),
    failed: buf.failed(),
    failedBytes: buf.failedBytes(),
  }

  console.debug("Transfer Finished", status)
  onCopyJobFinished(status)
}
